export const API_ENDPOINTS = {
    GET_WORK:'oeuvres',
    ADD_WORK:'add-oeuvre',
    GET_WORKS:'display-oeuvre',
    GET_ALL_WORKS:'display-all-oeuvre',
    GET_COMPOSER:'composers',
    ADD_COMPOSER:"add-composers",
    GET_COMPOSERS:'display-composers',
    GET_ALL_COMPOSERS:'display-all-composers',
    FILTERS:'filters',
    NATIONALTY:'display-nationality',
    USER:"user",
    UPDATE_PROFIL:"update-profil",
    UPDATE_PASSWORD:"update-password",
    STATISTIC_COMPOSER:"statistique-composers"
}